import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

export type MarketEmptyAction = {
  label: string
  onClick?: () => void
  to?: string
  variant?: 'primary' | 'ghost'
}

type MarketEmptyStateProps = {
  icon?: ReactNode
  title: string
  description?: string
  actions?: MarketEmptyAction[]
}

const DefaultIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
    <path
      d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const renderAction = (action: MarketEmptyAction, index: number) => {
  const className =
    action.variant === 'ghost'
      ? 'echat-btn echat-btn--ghost'
      : 'echat-btn echat-btn--primary'

  if (action.to) {
    return (
      <Link key={`${action.label}-${index}`} to={action.to} className={className}>
        {action.label}
      </Link>
    )
  }

  return (
    <button key={`${action.label}-${index}`} type="button" className={className} onClick={action.onClick}>
      {action.label}
    </button>
  )
}

export const MarketEmptyState = ({ icon, title, description, actions }: MarketEmptyStateProps) => (
  <article className="market-empty">
    <div className="market-empty__icon">{icon ?? <DefaultIcon />}</div>
    <h2 className="market-empty__title">{title}</h2>
    {description ? <p className="market-empty__description">{description}</p> : null}
    {actions && actions.length > 0 ? (
      <div className="market-empty__actions">{actions.map(renderAction)}</div>
    ) : null}
  </article>
)
